import { render, staticRenderFns } from "./QuotesInList.vue?vue&type=template&id=5cbddd06&scoped=true&"
import script from "./QuotesInList.vue?vue&type=script&lang=js&"
export * from "./QuotesInList.vue?vue&type=script&lang=js&"
import style0 from "./QuotesInList.vue?vue&type=style&index=0&id=5cbddd06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbddd06",
  null
  
)

export default component.exports